import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useForm } from "react-hook-form";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { preventMaxInput } from "../../Utils/constants";
import { Form } from "react-bootstrap";
const ChangePassword = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState([]);
  const [loader, setLoader] = useState(false);
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const setAccountModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAccountModal;
  });
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });
  const handle = (e) => {
    if (showPassword.includes(e)) {
      setShowPassword((prev) => {
        return prev?.filter((res) => {
          return res != e;
        });
      });
    } else {
      setShowPassword([...showPassword, e]);
    }
  };
  const onSubmit = async (body) => {
    setLoader(true);
    const obj = {
      oldPassword: body?.oldpassword,
      newPassword: body?.confirmPassword,
    };
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        setAccountModal({});
        logoutUser();

        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
    setLoader(false);
  };
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);
  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      id="js_loginPassword_from"
      className="pwd-model setting-item"
    >
      <div
        className="caption-text border-blue"
        translate="label_pwd_login_title"
      >
        Change Login Password
      </div>
      <div className="form-group">
        <label className="form-label colon" translate="label_pwd_old">
          Current Password
        </label>
        <div
          className={`input-case fr ${
            !isEmpty(errors.oldpassword) ? "input-case-error" : ""
          }`}
        >
          <input
            className="input-control fr js_paste_disabled"
            type={showPassword.includes("old") ? "text" : "password"}
            maxLength={12}
            minLength={6}
            placeholder="Please fill in current password"
            {...register("oldpassword", {
              required: "Please enter old password",
              validate: (value) => {
                if (value === "") {
                  return true;
                }
                if (!!value.trim()) {
                  return true;
                } else {
                  return "White space are not allowed";
                }
              },
              minLength: {
                value: 8,
                message: "Password should contain atleast 8 characters",
              },
              maxLength: {
                value: 12,
                message: "Password should contain maximum 12 characters",
              },
            })}
          />
          <div
            onClick={() => handle("old")}
            className={`mcac-icon icon-eyes${
              showPassword.includes("old") ? "-close" : ""
            }`}
          />{" "}
          {errors.oldpassword && errors.oldpassword.message && (
            <div class="error-tips">{errors.oldpassword.message}</div>
          )}
        </div>
      </div>
      <div className="form-group">
        <label className="form-label colon" translate="label_pwd_new">
          New Password
        </label>
        <div
          className={`input-case fr ${
            !isEmpty(errors.newPassword) ? "input-case-error" : ""
          }`}
        >
          <input
            className="input-control js_paste_disabled"
            type={showPassword.includes("new") ? "text" : "password"}
            maxLength={12}
            minLength={6}
            {...register("newPassword", {
              required: "Please enter new password",
              validate: (value) => {
                if (value === "") {
                  return true;
                }
                if (!!value.trim()) {
                  return true;
                } else {
                  return "White space are not allowed";
                }
              },
            })}
            placeholder="Please fill in new password"
          />
          <div
            className={`mcac-icon icon-eyes${
              showPassword.includes("new") ? "-close" : ""
            }`}
          />{" "}
          {errors.newPassword && errors.newPassword.message && (
            <div class="error-tips">{errors.newPassword.message}</div>
          )}
        </div>
      </div>
      <div className="form-group">
        <label className="form-label colon" translate="label_pwd_confirm">
          Confirm Password
        </label>
        <div
          className={`input-case fr ${
            !isEmpty(errors.confirmPassword) ? "input-case-error" : ""
          }`}
        >
          <input
            className="input-control js_paste_disabled"
            type={showPassword.includes("confirmNew") ? "text" : "password"}
            maxLength={12}
            minLength={6}
            onInput={(e) => preventMaxInput(e)}
            {...register("confirmPassword", {
              required: {
                value: true,
                message: "Please enter confirm password",
              },
              validate: (value) => {
                if (value === "") {
                  return true;
                }
                if (!isEmpty(watch("newPassword"))) {
                  if (value == watch("newPassword")) {
                    return true;
                  } else {
                    return "password and confirm password does not match.";
                  }
                }
              },
            })}
            onChange={(e) => {
              setValue("confirmPassword", e.target.value, {
                shouldValidate: true,
              });
            }}
            placeholder="Please fill in confirm password"
          />
          <div
            className={`mcac-icon icon-eyes${
              showPassword.includes("confirmNew") ? "-close" : ""
            }`}
          />{" "}
          {errors.confirmPassword && errors.confirmPassword.message && (
            <div class="error-tips">{errors.confirmPassword.message}</div>
          )}
        </div>
      </div>
      <div className="setting-item-footer">
        <button
          type="submit"
          className="button btn-submit"
          translate="button_submit"
        >
          Submit
        </button>
      </div>
    </Form>
  );
};

export default ChangePassword;
